<!--
  ~ Copyright 2022-2026 NXGN Management, LLC. All Rights Reserved.
  -->

<div class="offset-md-3" [formGroup]="parentGroup">
  <fieldset>
    <div formGroupName="generalInfo">
      <div *ngIf="!isWorldPay() && isEditable" class="form-group">
        <label class="col-sm-8 control-label" for="merchantIdEdit">
          Merchant ID
        </label>
        <div class="col-md-8">
          <div class="row">
            <div class="col-md-6">
              <input
                class="form-control cursorDisable"
                type="number"
                formControlName="merchantId"
                id="merchantIdEdit"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="form-group fieldIsRequired">
        <label class="col-sm-8 control-label"> Merchant Name </label>
        <div class="col-md-8">
          <input
            class="form-control"
            type="text"
            name="merchantName"
            id="merchantNameEdit"
            [ngClass]="{
              'is-invalid':
                generalInfoFormControl.merchantName.invalid &&
                (generalInfoFormControl.merchantName.dirty ||
                  generalInfoFormControl.merchantName.touched)
            }"
            formControlName="merchantName"
          />
          <div
            class="formValidationMessage mt-1"
            role="alert"
            *ngIf="
              generalInfoFormControl.merchantName.invalid &&
              (generalInfoFormControl.merchantName.dirty ||
                generalInfoFormControl.merchantName.touched)
            "
          >
            <div class="mt-1">
              <div *ngIf="generalInfoFormControl.merchantName.errors?.required">
                Field is required.
              </div>
              <div
                *ngIf="generalInfoFormControl.merchantName.errors?.maxlength"
              >
                Content is too long. Please shorten it.
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        *ngIf="!isInstaMed() && !isGlobalPayments()"
        class="form-group"
        [ngClass]="{ fieldIsRequired: isWorldPay() }"
      >
        <label class="col-sm-8 control-label"> Doing Business as </label>
        <div class="col-md-8">
          <input
            class="form-control"
            type="text"
            formControlName="doingBusinessAs"
            [ngClass]="{
              'is-invalid':
                generalInfoFormControl.doingBusinessAs.invalid &&
                (generalInfoFormControl.doingBusinessAs.dirty ||
                  generalInfoFormControl.doingBusinessAs.touched)
            }"
            id="doingBusinessAsEdit"
          />
          <div
            class="formValidationMessage mt-1"
            role="alert"
            *ngIf="
              generalInfoFormControl.doingBusinessAs.invalid &&
              (generalInfoFormControl.doingBusinessAs.dirty ||
                generalInfoFormControl.doingBusinessAs.touched)
            "
          >
            <div
              *ngIf="generalInfoFormControl.doingBusinessAs.errors?.required"
            >
              Field is required.
            </div>
            <div class="mt-1">
              <div
                *ngIf="generalInfoFormControl.doingBusinessAs.errors?.maxlength"
              >
                Content is too long. Please shorten it.
              </div>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="!isInstaMed() && !isGlobalPayments()" class="form-group">
        <label class="col-sm-8 control-label"> Also Known as </label>
        <div class="col-md-8">
          <input
            class="form-control"
            type="text"
            formControlName="alsoKnownAsName"
            id="alsoKnownAsNameEdit"
          />
        </div>
      </div>

      <div
        class="form-group"
        [ngClass]="{
          fieldIsRequired:
            generalInfoFormControl?.instaMedConversionStatus?.value
        }"
      >
        <label class="col-sm-8 control-label" for="externalMerchantIdEdit">
          SiteGen Practice ID
        </label>
        <div class="col-md-8">
          <div class="row">
            <div class="col-md-9">
              <input
                class="form-control"
                type="number"
                formControlName="externalMerchantId"
                [ngClass]="{
                  'is-invalid':
                    generalInfoFormControl.externalMerchantId.invalid &&
                    (generalInfoFormControl.externalMerchantId.dirty ||
                      generalInfoFormControl.externalMerchantId.touched)
                }"
                max="999999999999"
                min="0"
                id="externalMerchantIdEdit"
                (input)="
                  handlePracticeId(
                    generalInfoFormControl.externalMerchantId.value
                  )
                "
              />
            </div>
          </div>
          <div
            class="formValidationMessage mt-1"
            role="alert"
            *ngIf="
              generalInfoFormControl.externalMerchantId.invalid &&
              (generalInfoFormControl.externalMerchantId.dirty ||
                generalInfoFormControl.externalMerchantId.touched)
            "
          >
            <div class="mt-1">
              <div
                *ngIf="generalInfoFormControl.externalMerchantId.errors?.max"
              >
                Content is too long. Please shorten it.
              </div>
              <div
                *ngIf="generalInfoFormControl.externalMerchantId.errors?.min"
              >
                Value cannot be negative.
              </div>
              <div
                *ngIf="
                  generalInfoFormControl.externalMerchantId.errors?.required
                "
              >
                Field is required.
              </div>
            </div>
          </div>
          <div
            class="formValidationMessage mt-1"
            *ngIf="
              merchantMigrationDetails().practiceId &&
              generalInfoFormControl.externalMerchantId.valid &&
              !isPracticeIDValid &&
              generalInfoFormControl.instaMedConversionStatus.disabled
            "
          >
            Given Practice ID does not match with the previous MMID.
          </div>
        </div>
      </div>

      <div class="form-group">
        <label class="col-sm-8 control-label" for="practiceNameSearch">
          Practice Name Search
        </label>
        <div class="col-md-8">
          <div style="display: flex; flex-direction: row">
            <input
              type="text"
              class="form-control"
              id="practiceNameSearch"
              formControlName="practiceNameSearch"
              [placeholder]="
                authService.hasProvisionRole()
                  ? ''
                  : 'Start typing practice name...'
              "
              (input)="onPracticeNameInput()"
              [attr.autocomplete]="'off'"
              [readonly]="authService.hasProvisionRole()"
            />
            <span
              *ngIf="
                loadingClients &&
                generalInfoFormControl.practiceNameSearch.value.length > 0
              "
              class="spinner-border spinner-border-sm"
              style="margin-top: 10px; position: relative; right: 23px"
              role="status"
              aria-hidden="true"
            ></span>
          </div>
          <ul
            *ngIf="
              !loadingClients &&
              hasSearchedClients &&
              filteredClients.length == 0 &&
              generalInfoFormControl.practiceNameSearch.dirty &&
              generalInfoFormControl.practiceNameSearch.value.length > 2 &&
              !generalInfoFormControl.siteId.value?.length
            "
            class="list-group mt-1"
            style="max-height: 200px; overflow-y: auto; border: 1px solid #ddd"
          >
            <li class="list-group-item list-group-item-action">
              No results found for given practice name
            </li>
          </ul>
          <ul
            *ngIf="filteredClients.length > 0"
            class="list-group mt-1"
            style="max-height: 200px; overflow-y: auto; border: 1px solid #ddd"
          >
            <li
              *ngFor="let client of filteredClients"
              class="list-group-item list-group-item-action"
              (click)="selectClient(client)"
            >
              <div>
                <strong> {{ client.clientName }} </strong>
              </div>
              <div>Site ID: {{ client.siteId }}</div>
              <div>Enterprise ID: {{ client.enterpriseId }}</div>
              <div>
                Enterprise Practice ID: {{ client.enterprisePracticeId }}
              </div>
              <div>Practice Name: {{ client.practiceName }}</div>
            </li>
          </ul>
        </div>
      </div>

      <!-- Auto-filled client info -->
      <div class="form-group">
        <label class="col-sm-8 control-label" for="siteId">Site ID</label>
        <div class="col-md-8">
          <input
            type="text"
            class="form-control"
            id="siteId"
            formControlName="siteId"
            readonly
          />
        </div>
      </div>

      <div class="form-group">
        <label class="col-sm-8 control-label" for="enterpriseId"
          >Enterprise ID</label
        >
        <div class="col-md-8">
          <input
            type="text"
            class="form-control"
            id="enterpriseId"
            formControlName="enterpriseId"
            readonly
          />
        </div>
      </div>

      <div class="form-group">
        <label class="col-sm-8 control-label" for="enterprisePracticeId"
          >Enterprise Practice ID</label
        >
        <div class="col-md-8">
          <input
            type="text"
            class="form-control"
            id="enterprisePracticeId"
            formControlName="enterprisePracticeId"
            readonly
          />
        </div>
      </div>

      <div class="form-group">
        <label class="col-sm-8 control-label" for="practiceName"
          >Practice Name</label
        >
        <div class="col-md-8">
          <input
            type="text"
            class="form-control"
            id="practiceName"
            formControlName="practiceName"
            readonly
          />
        </div>
      </div>

      <div class="form-group">
        <label class="col-sm-8 control-label" for="clientName"
          >Client Name</label
        >
        <div class="col-md-8">
          <input
            type="text"
            class="form-control"
            id="clientName"
            formControlName="clientName"
            readonly
          />
        </div>
      </div>

      <div class="form-group">
        <label class="col-sm-8 control-label" for="gcn">GCN</label>
        <div class="col-md-8">
          <input
            type="text"
            class="form-control"
            id="gcn"
            formControlName="gcn"
            readonly
          />
        </div>
      </div>

      <!-- Location Dropdown List -->
      <div class="form-group">
        <label class="col-sm-8 control-label" for="locationNameSearch">
          Location Search
        </label>
        <div class="col-md-8" style="position: relative">
          <div style="display: flex; flex-direction: row">
            <input
              id="locationNameSearch"
              type="text"
              class="form-control"
              formControlName="locationNameSearch"
              [placeholder]="locationPlaceholderText"
              (input)="onLocationInput()"
              [attr.autocomplete]="'off'"
              [readonly]="authService.hasProvisionRole()"
            />
            <span
              *ngIf="
                hasSearchedClients &&
                loadingLocations &&
                generalInfoFormControl.locationNameSearch.value.length > 0
              "
              class="spinner-border spinner-border-sm"
              style="margin-top: 10px; position: relative; right: 23px"
              role="status"
              aria-hidden="true"
            ></span>
          </div>

          <ul
            *ngIf="hasSearchedLocations"
            class="list-group location-search-dropdown"
            style="max-height: 200px; overflow-y: auto"
          >
            <li
              *ngIf="
                !loadingLocations &&
                filteredLocations.length == 0 &&
                generalInfoFormControl.locationNameSearch.dirty &&
                generalInfoFormControl.locationNameSearch.value.length > 2 &&
                generalInfoFormControl.locationId.value.length === 0 &&
                !errorLoadingLocations
              "
              class="list-group-item list-group-item-action"
            >
              No results found for given location
            </li>
            <li
              *ngIf="
                !loadingLocations &&
                errorLoadingLocations &&
                generalInfoFormControl.locationNameSearch.dirty &&
                generalInfoFormControl.locationNameSearch.value.length > 2 &&
                generalInfoFormControl.locationId.value.length === 0
              "
              class="list-group-item list-group-item-action"
            >
              Error fetching locations for given client
            </li>
            <li
              *ngFor="let location of filteredLocations"
              class="list-group-item list-group-item-action"
              (click)="selectLocation(location)"
              role="button"
              tabindex="0"
            >
              <div>
                <strong> {{ location.locationName }} </strong>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <!-- Location Alias -->
      <div class="form-group">
        <label class="col-sm-8 control-label" for="locationAlias">
          Location Alias</label
        >
        <div class="col-md-8">
          <input
            type="text"
            class="form-control"
            id="locationAlias"
            formControlName="locationAlias"
            maxlength="40"
          />
        </div>
      </div>

      <div class="form-group fieldIsRequired">
        <label class="col-sm-8 control-label"> SAP ID </label>
        <div class="col-md-8">
          <div class="row">
            <div class="col-md-9">
              <input
                class="form-control"
                type="text"
                [ngClass]="{
                  'is-invalid':
                    generalInfoFormControl.customerAccountNumber.invalid &&
                    (generalInfoFormControl.customerAccountNumber.dirty ||
                      generalInfoFormControl.customerAccountNumber.touched)
                }"
                formControlName="customerAccountNumber"
                id="customerAccountNumberEdit"
              />
            </div>
          </div>
          <div
            class="formValidationMessage mt-1"
            role="alert"
            *ngIf="
              generalInfoFormControl.customerAccountNumber.invalid &&
              (generalInfoFormControl.customerAccountNumber.dirty ||
                generalInfoFormControl.customerAccountNumber.touched)
            "
          >
            <div class="mt-1">
              <div
                *ngIf="
                  generalInfoFormControl.customerAccountNumber.errors?.required
                "
              >
                Field is required.
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        *ngIf="
          isInstaMed() &&
          isEditable &&
          !authService.hasProvisionRole() &&
          isInstamedMigrationMerchant &&
          !isMerchantMigrated
        "
      >
        <div class="form-group">
          <label
            class="col-sm-8 control-label"
            for="previousMMID"
            title="Convert patient credit card tokens from TokenEx to InstaMed."
          >
            Token Conversion Date
          </label>
          <div class="col-md-8">
            <div class="row">
              <div class="col-6">
                <div class="input-group">
                  <input
                    class="form-control"
                    type="text"
                    name="tokenConversionDate"
                    id="tokenConversionDate"
                    formControlName="tokenConversionDate"
                    matInput
                    [matDatepicker]="picker"
                    [max]="maxDate"
                    [min]="minDate"
                    title="Convert patient credit card tokens from TokenEx to InstaMed."
                    placeholder="MM/DD/YYYY"
                  />
                  <div class="input-group-append">
                    <mat-datepicker-toggle
                      matSuffix
                      [for]="picker"
                    ></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        *ngIf="
          isInstaMed() && generalInfoFormControl.instaMedConversionStatus.value
        "
      >
        <div class="form-group" [ngClass]="{ fieldIsRequired: isInstaMed() }">
          <label class="col-sm-12 control-label" for="previousMMID">
            Previous MMID (Internal)
          </label>
          <div class="col-md-12">
            <div class="d-flex">
              <div class="row">
                <div class="col-6">
                  <input
                    class="form-control"
                    type="number"
                    [ngClass]="{
                      'is-invalid':
                        generalInfoFormControl.previousMMID.invalid &&
                        (generalInfoFormControl.previousMMID.dirty ||
                          generalInfoFormControl.previousMMID.touched)
                    }"
                    (input)="resetMerchantMigrationDetails()"
                    formControlName="previousMMID"
                    id="previousMMID"
                  />
                </div>
                <div class="col-6">
                  <button
                    class="btn btn-primary"
                    type="button"
                    (click)="fetchPreviousMmidInfo()"
                    [disabled]="generalInfoFormControl.previousMMID.disabled"
                  >
                    <span
                      class="spinner-border spinner-border-sm"
                      *ngIf="isMigrationDetailsLoading"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Get Merchant Info
                  </button>
                  <button
                    class="btn btn-danger ml-1"
                    type="button"
                    (click)="handlePreviousMmidLinkage()"
                    [disabled]="!isCancelButtonEnabled()"
                    *ngIf="
                      isEditable &&
                      !isMerchantMigrated &&
                      !authService.hasProvisionRole()
                    "
                  >
                    <span
                      class="spinner-border spinner-border-sm"
                      *ngIf="cancellationInProgress"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Cancel
                  </button>
                </div>
              </div>
            </div>
            <div
              class="formValidationMessage mt-1"
              role="alert"
              *ngIf="
                generalInfoFormControl.previousMMID.invalid &&
                (generalInfoFormControl.previousMMID.dirty ||
                  generalInfoFormControl.previousMMID.touched)
              "
            >
              <div class="mt-1">
                <div
                  *ngIf="generalInfoFormControl.previousMMID.errors?.pattern"
                >
                  Previous mmid must be in digits
                </div>
                <div
                  *ngIf="generalInfoFormControl.previousMMID.errors?.minlength"
                >
                  Previous mmid must be minimum 10 digits.
                </div>
                <div
                  *ngIf="generalInfoFormControl.previousMMID.errors?.required"
                >
                  Field is required.
                </div>
              </div>
            </div>
            <div
              *ngIf="
                generalInfoFormControl.previousMMID.valid &&
                (generalInfoFormControl.previousMMID.dirty ||
                  generalInfoFormControl.previousMMID.touched)
              "
            >
              <div
                class="formValidationMessage mt-1"
                *ngIf="!generalInfoFormControl.externalMerchantId.value"
              >
                Please add a Practice ID.
              </div>
              <div
                class="formValidationMessage mt-1"
                *ngIf="
                  !hasPracticeId &&
                  generalInfoFormControl.externalMerchantId.value
                "
              >
                Previous MMID does not have a Practice ID.
              </div>
              <div
                class="formValidationMessage mt-1"
                *ngIf="
                  !isPracticeIDValid &&
                  hasPracticeId &&
                  generalInfoFormControl.externalMerchantId.value
                "
              >
                Previous MMID does not belong to the above mentioned Practice
                ID.
              </div>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="isInstaMed() && displayMigrationDetails">
        <div class="form-group">
          <div class="col-md-12">
            <div class="row mt-1">
              <label
                class="col-md-6 col-lg-4 control-label text-right mt-auto mb-auto pr-0"
              >
                Previous Merchant Name :
              </label>
              <label class="col-md-6 col-lg-4 pl-1 mt-auto mb-auto">
                {{ merchantMigrationDetails().previousMerchantName }}
              </label>
            </div>
          </div>
        </div>

        <div class="form-group">
          <div class="col-md-12">
            <div class="row mt-1">
              <label
                class="col-md-6 col-lg-4 control-label text-right mt-auto mb-auto pr-0"
              >
                Previous Processor :
              </label>
              <label class="col-md-6 col-lg-4 mt-auto mb-auto pl-1">
                {{ merchantMigrationDetails().previousProcessor }}
              </label>
            </div>
          </div>
        </div>
      </div>

      <div class="form-group" *ngIf="isInstaMed() && displayMigrationVerbiage">
        <div class="col-md-12">
          <div class="row mt-1">
            <label
              class="col-1 control-label text-right mt-auto mb-auto pr-0 noteLabel"
            >
              Note :
            </label>
            <label class="col-10 text-left mt-auto mb-auto pl-1">
              {{ migrationInfo }}
            </label>
          </div>
        </div>
      </div>

      <div class="form-group" *ngIf="isInstaMed() || isGlobalPayments()">
        <div class="col-md-8">
          <div class="row">
            <div class="recordValueWide col-1">
              <input
                class="big-checkbox"
                type="checkbox"
                formControlName="suppressZeroDollarPayment"
              />
            </div>
            <div class="col-md-10">No Payments When $0 Balance Owed</div>
          </div>
        </div>
      </div>

      <div class="form-group" *ngIf="isInstaMed() || isGlobalPayments()">
        <div class="col-md-8">
          <div class="row">
            <div class="recordValueWide col-1">
              <input
                class="big-checkbox"
                type="checkbox"
                formControlName="achEcheckEnabled"
              />
            </div>
            <div class="col-md-10">ACH/eCheck</div>
          </div>
        </div>
      </div>

      <div class="form-group" *ngIf="isInstaMed() || isGlobalPayments()">
        <div class="col-md-8">
          <div class="row">
            <div class="recordValueWide col-1">
              <input
                class="big-checkbox"
                type="checkbox"
                formControlName="amexEnabled"
              />
            </div>
            <div class="col-md-10">AMEX</div>
          </div>
        </div>
      </div>

      <div class="form-group" *ngIf="isInstaMed() || isGlobalPayments()">
        <div class="col-md-8">
          <div class="row">
            <div class="recordValueWide col-1">
              <input
                class="big-checkbox"
                type="checkbox"
                formControlName="balanceIncludesBadDebt"
              />
            </div>
            <div class="col-md-10">Patient Balance Includes Bad Debt</div>
          </div>
        </div>
      </div>

      <div class="form-group" *ngIf="isInstaMed() || isGlobalPayments()">
        <div class="col-md-8">
          <div class="row">
            <div class="recordValueWide col-1">
              <input
                class="big-checkbox"
                type="checkbox"
                formControlName="ngepmStatement"
              />
            </div>
            <div class="col-md-10">NGEPM Statement</div>
          </div>
        </div>
      </div>

      <div
        class="form-group"
        *ngIf="(isInstaMed() || isGlobalPayments()) && isEditable"
      >
        <div class="col-md-8">
          <div class="row">
            <div class="recordValueWide col-1">
              <input
                class="big-checkbox"
                type="checkbox"
                formControlName="directBatching"
              />
            </div>
            <div class="col-md-10">Direct Batching</div>
          </div>
        </div>
      </div>

      <div *ngIf="!isInstaMed() && !isGlobalPayments()">
        <div class="form-group" [ngClass]="{ fieldIsRequired: isWorldPay() }">
          <label class="col-sm-8 control-label" for="phoneNumber">
            Phone Number
          </label>
          <div class="col-md-8">
            <input
              class="form-control"
              type="text"
              [ngClass]="{
                'is-invalid':
                  generalInfoFormControl.phoneNumber.invalid &&
                  (generalInfoFormControl.phoneNumber.dirty ||
                    generalInfoFormControl.phoneNumber.touched)
              }"
              formControlName="phoneNumber"
              id="phoneNumber"
            />
            <div
              class="formValidationMessage mt-1"
              role="alert"
              *ngIf="
                generalInfoFormControl.phoneNumber.invalid &&
                (generalInfoFormControl.phoneNumber.dirty ||
                  generalInfoFormControl.phoneNumber.touched)
              "
            >
              <div class="mt-1">
                <div *ngIf="generalInfoFormControl.phoneNumber.errors?.pattern">
                  Phone number must be 10 digits.
                </div>
                <div
                  *ngIf="generalInfoFormControl.phoneNumber.errors?.required"
                >
                  Field is required.
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="form-group fieldIsRequired">
          <label class="col-sm-8 control-label" for="maxTransactionLimit">
            Transaction Limit
          </label>
          <div class="col-md-8">
            <div class="row">
              <div class="col-sm-6 input-group" id="transactionAmount">
                <div class="input-group-prepend">
                  <span class="input-group-text">$</span>
                </div>
                <input
                  class="form-control text-right"
                  type="number"
                  formControlName="maxTransactionLimit"
                  id="maxTransactionLimit"
                  [ngClass]="{
                    'is-invalid':
                      generalInfoFormControl.maxTransactionLimit.invalid &&
                      (generalInfoFormControl.maxTransactionLimit.dirty ||
                        generalInfoFormControl.maxTransactionLimit.touched)
                  }"
                  step="0.01"
                />
              </div>
            </div>
            <div
              class="formValidationMessage mt-1"
              role="alert"
              *ngIf="
                generalInfoFormControl.maxTransactionLimit.invalid &&
                (generalInfoFormControl.maxTransactionLimit.dirty ||
                  generalInfoFormControl.maxTransactionLimit.touched)
              "
            >
              <div class="mt-1">
                <div
                  *ngIf="
                    generalInfoFormControl.maxTransactionLimit.errors?.required
                  "
                >
                  Field is required.
                </div>
                <div
                  *ngIf="
                    generalInfoFormControl.maxTransactionLimit.errors?.pattern
                  "
                >
                  Please enter a valid dollar amount.
                </div>
                <div
                  *ngIf="generalInfoFormControl.maxTransactionLimit.errors?.min"
                >
                  Value cannot be negative.
                </div>
                <div
                  *ngIf="generalInfoFormControl.maxTransactionLimit.errors?.max"
                >
                  Value cannot be greater than 999999.99
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="isWorldPay()">
        <div class="form-group" [ngClass]="{ fieldIsRequired: true }">
          <label class="col-sm-8 control-label"> Billing Descriptor </label>
          <div class="col-md-8">
            <input
              class="form-control"
              type="text"
              formControlName="billingDescriptor"
              [ngClass]="{
                'is-invalid':
                  generalInfoFormControl.billingDescriptor.invalid &&
                  (generalInfoFormControl.billingDescriptor.dirty ||
                    generalInfoFormControl.billingDescriptor.touched)
              }"
              id="billingDescriptorEdit"
            />
            <div
              class="formValidationMessage mt-1"
              role="alert"
              *ngIf="
                generalInfoFormControl.billingDescriptor.invalid &&
                (generalInfoFormControl.billingDescriptor.dirty ||
                  generalInfoFormControl.billingDescriptor.touched)
              "
            >
              <div class="mt-1">
                <div
                  *ngIf="
                    generalInfoFormControl.billingDescriptor.errors?.required
                  "
                >
                  Field is required.
                </div>
                <div
                  *ngIf="
                    generalInfoFormControl.billingDescriptor.errors?.maxlength
                  "
                >
                  Max Length is 25 characters.
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="form-group" [ngClass]="{ fieldIsRequired: isWorldPay() }">
          <label class="col-sm-8 control-label"> Ownership Type </label>
          <div class="col-md-8">
            <div class="row">
              <div class="col-md-8">
                <select
                  class="form-control"
                  formControlName="ownershipType"
                  [ngClass]="{
                    'is-invalid':
                      generalInfoFormControl.ownershipType.invalid &&
                      (generalInfoFormControl.ownershipType.dirty ||
                        generalInfoFormControl.ownershipType.touched)
                  }"
                  id="ownershipTypeEdit"
                  (change)="resetContactTypes()"
                >
                  <option value="">--- Select Ownership Type ---</option>
                  <option
                    *ngFor="let type of ownershipTypes | keyvalue"
                    [value]="type.key"
                  >
                    {{ type.value }}
                  </option>
                </select>
              </div>
            </div>
            <div
              class="formValidationMessage mt-1"
              role="alert"
              data-ng-messages="generalInfoFormControl.ownershipType.$error"
              *ngIf="
                generalInfoFormControl.ownershipType.invalid &&
                (generalInfoFormControl.ownershipType.dirty ||
                  generalInfoFormControl.ownershipType.touched)
              "
            >
              <div
                class="mt-1"
                *ngIf="generalInfoFormControl.ownershipType.errors?.required"
              >
                Field is required.
              </div>
            </div>
          </div>
        </div>

        <div class="form-group" [ngClass]="{ fieldIsRequired: true }">
          <label class="col-sm-8 control-label"> Business Type </label>
          <div class="col-md-8">
            <div class="row">
              <div class="col-md-8">
                <select
                  class="form-control"
                  formControlName="businessType"
                  [ngClass]="{
                    'is-invalid':
                      generalInfoFormControl.businessType.invalid &&
                      (generalInfoFormControl.businessType.dirty ||
                        generalInfoFormControl.businessType.touched)
                  }"
                  id="businessTypeEdit"
                >
                  <option value="">--- Select Business Type ---</option>
                  <option
                    *ngFor="let type of businessTypes | keyvalue"
                    [value]="type.key"
                  >
                    {{ type.value }}
                  </option>
                </select>
              </div>
            </div>
            <div
              class="formValidationMessage mt-1"
              role="alert"
              data-ng-messages="generalInfoFormControl.businessType.$error"
              *ngIf="
                generalInfoFormControl.businessType.invalid &&
                (generalInfoFormControl.businessType.dirty ||
                  generalInfoFormControl.businessType.touched)
              "
            >
              <div *ngIf="generalInfoFormControl.businessType.errors?.required">
                Field is required.
              </div>
            </div>
          </div>
        </div>

        <div class="form-group" [ngClass]="{ fieldIsRequired: true }">
          <label class="col-sm-8 control-label"> SIC/MCC Code </label>
          <div class="col-md-6">
            <div class="row">
              <div class="col-md-8">
                <select
                  class="form-control"
                  [ngClass]="{
                    'is-invalid':
                      generalInfoFormControl.mccCode.invalid &&
                      (generalInfoFormControl.mccCode.dirty ||
                        generalInfoFormControl.mccCode.touched)
                  }"
                  formControlName="mccCode"
                  id="mccCodeEdit"
                >
                  <option
                    *ngFor="let code of sicMccCodes | keyvalue"
                    [value]="code.key"
                  >
                    {{ code.value.label }}
                  </option>
                </select>
              </div>
            </div>
            <div
              class="formValidationMessage mt-1"
              role="alert"
              *ngIf="
                generalInfoFormControl.mccCode.invalid &&
                (generalInfoFormControl.mccCode.dirty ||
                  generalInfoFormControl.mccCode.touched)
              "
            >
              <div
                class="mt-1"
                *ngIf="generalInfoFormControl.mccCode.errors?.required"
              >
                Field is required.
              </div>
            </div>
          </div>
        </div>

        <div class="form-group" [ngClass]="{ fieldIsRequired: true }">
          <label class="col-sm-8 control-label">
            Business Established Date
          </label>
          <div class="col-md-8">
            <div class="input-group">
              <input
                class="form-control"
                name="businessEstablishedDate"
                matInput
                [matDatepicker]="businessEstablishedDate"
                id="businessEstablishedDate"
                formControlName="businessEstablishedDate"
                [ngClass]="{
                  'is-invalid':
                    generalInfoFormControl.businessEstablishedDate?.invalid &&
                    (generalInfoFormControl.businessEstablishedDate?.dirty ||
                      generalInfoFormControl.businessEstablishedDate?.touched)
                }"
                [max]="maxDate"
              />
              <div class="input-group-append">
                <mat-datepicker-toggle
                  matSuffix
                  [for]="businessEstablishedDate"
                ></mat-datepicker-toggle>
                <mat-datepicker #businessEstablishedDate></mat-datepicker>
              </div>
            </div>
            <div
              class="formValidationMessage mt-1"
              role="alert"
              data-ng-messages="generalInfoFormControl.businessEstablishedDate.$error"
              *ngIf="
                generalInfoFormControl.businessEstablishedDate.invalid &&
                (generalInfoFormControl.businessEstablishedDate?.dirty ||
                  generalInfoFormControl.businessEstablishedDate?.touched)
              "
            >
              <div class="mt-1">
                <div
                  *ngIf="
                    generalInfoFormControl.businessEstablishedDate.errors
                      ?.required
                  "
                >
                  Field is required.
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="form-group" [ngClass]="{ fieldIsRequired: true }">
          <label class="col-sm-8 control-label"> Website URL Address </label>
          <div class="col-md-8">
            <input
              class="form-control"
              type="text"
              [ngClass]="{
                'is-invalid':
                  generalInfoFormControl.websiteURL?.invalid &&
                  (generalInfoFormControl.websiteURL?.dirty ||
                    generalInfoFormControl.websiteURL?.touched)
              }"
              formControlName="websiteURL"
              id="websiteURLEdit"
            />
            <div
              class="formValidationMessage mt-1"
              role="alert"
              *ngIf="
                generalInfoFormControl.websiteURL.invalid &&
                (generalInfoFormControl.websiteURL?.dirty ||
                  generalInfoFormControl.websiteURL?.touched)
              "
            >
              <div class="mt-1">
                <div *ngIf="generalInfoFormControl.websiteURL.errors?.required">
                  Field is required.
                </div>
                <div *ngIf="generalInfoFormControl.websiteURL.errors?.pattern">
                  Invalid Website URL Address
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="form-group">
          <label class="col-sm-8 control-label" for="payApiCustomers">
            Pay API Customer
          </label>
          <div class="col-md-6">
            <div class="row">
              <div class="col-md-8">
                <select
                  class="form-control"
                  [compareWith]="byId"
                  formControlName="payApiCustomers"
                  id="payApiCustomers"
                >
                  <option
                    *ngFor="let customer of payApiCustomers"
                    [ngValue]="customer"
                  >
                    {{ customer.customerName }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </fieldset>
</div>
